import { keyBy, map } from "lodash";

export default arr => {
  return {
    byId: keyBy(arr, i => i.id),
    allIds: map(arr, i => i.id)
  };
};
